import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useAnalytics } from "../../../contexts/analytics/hooks";
import SystemBanner from "../../UIToolkit/molecules/SystemBanner";
import SystemButton from "../../UIToolkit/SystemButton/SystemButton";

type Props = { departmentId: string; retry: () => void };

/** Origins failed to load: the list is still all there, only the causes are missing — say so, and offer to load them again. */
export const RequestOriginsLoadNotice: FC<Props> = ({ departmentId, retry }) => {
	const { t } = useTranslation();
	const { track } = useAnalytics();
	const onRetry = (): void => {
		track("request_origins_retry_clicked", { department_id: departmentId });
		retry();
	};
	return (
		<SystemBanner
			live
			tone="warning"
			dataTestId="request-origins-load-failed"
			title={t("request.origins.loadFailed.title")}
			description={t("request.origins.loadFailed.body")}
			action={
				<SystemButton buttonVariant="secondary" size="compact" onClick={onRetry} data-testid="request-origins-retry-button">
					{t("retry")}
				</SystemButton>
			}
		/>
	);
};
